(() => {
	angular
		.module('main')
		.directive('sectionContractAndQuestion', sectionContractAndQuestion);

	sectionContractAndQuestion.$inject = [
		'stringModifierService',
		'templateRequestsService',
		'messageService',
		'$timeout'
	];

	function sectionContractAndQuestion(
		stringModifierService,
		templateRequestsService,
		messageService,
		$timeout
	) {
		return {
			restrict: 'AE',
			template: `<section>
                    <div class="row show-grid" style="margin-bottom: 30px">
                        <div class="col-xs-12">
                            <div class="col-gray">
                                <div class="row ">
                                    <div class="col-xs-12 col-sm-5">
                                        <h4>Do you want to add a contract?</h4> </div>
                                    <div class="col-xs-12 col-sm-7 col-md-3">
                                        <div class="flex-row flex-wrap-xs">
                                            <div class="select-style flex-grow-1 flex-with-full">
                                                <select ng-model="chosenContract" ng-change="chooseContract()" ng-options="contract as contract.name for contract in contracts | orderBy" ng-disabled="button_disable">
                                                    <option value="">Choose Contract</option>
                                                </select>
                                            </div>
                                            <btn-edit sn-text='Edit contract' class="btn-edit-md hide visible-sm" 
                                                      ng-click="openEditSelectContract(chosenContract, $event)" 
                                                      ng-disabled="!chosenContract || (isStartContractSigned && snData.chosenContract.id === startContractId)"
                                                      ></btn-edit>
                                            <btn-edit sn-text='Edit contract' class="btn-edit-sm visible-xs hidden-sm" 
                                                      ng-click="openEditSelectContract(chosenContract, $event)" 
                                                      ng-disabled="!chosenContract || (isStartContractSigned && snData.chosenContract.id === startContractId)"
                                                      ></btn-edit>
                                        </div>
                                    </div>
                                  
                                    <div class="col-xs-3 col-sm-5 col-md-3 btn-edit-md hidden-xs hidden-sm">
                                        <btn-edit sn-text='Edit contract' 
                                                  ng-click="openEditSelectContract(chosenContract, $event)" 
                                                  ng-disabled="!chosenContract || (isStartContractSigned && snData.chosenContract.id === startContractId)"
                                         ></btn-edit>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="editSelectContractModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <form name="editSelectContractModal" ng-submit="saveEditedContract($event)">
                                    <div class="modal-header">
                                        <button type="button" class="close" data-dismiss="modal" ng-disabled="button_disable" aria-hidden="true">&times;</button>
                                        <h3 class="modal-title">Edit Contract</h3> </div>
                                    <div class="modal-body">
                                        <h4>Text</h4>
                                        <sn-text-angular class="description" sn-model="editSelectContract.text" sn-tools="[['bold', 'italics', 'underline'], ['link'], [ 'ul', 'ol'],[ 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull' ],['reminderTokens' ]]" sn-name="editable_contract_text"></sn-text-angular>
                                    </div>
                                    <div class="modal-footer modal-foot">
                                        <button type="submit" class="btn btn-success btn-lg"> Save contract </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="row show-grid mb-30">
                        <div class="col-xs-12">
                            <div class="col-gray">
                                <div class="row ">
                                    <div class="col-xs-12 col-sm-5">
                                        <h4>Do you want to add a questionnaire?</h4> </div>
                                    <div class="col-xs-12 col-sm-7 col-md-3">
                                        <div class="select-style">
                                            <select ng-model="chosenQuestionnaire" ng-options="questionnaire.name for questionnaire in questionnaires | orderBy" ng-disabled="button_disable">
                                                <option value="">Choose Questionnaire</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
`,
			scope: {
				snData: '='
			},
			replace: true,
			transclude: true,
			link(scope, element) {
				const modalID = '#editSelectContractModal';
				scope.editSelectContract = {};
				scope.editEmptyContractObj = {
					text: ''
				};

				const showErrorMessage = () => {
					messageService.showToaster('e_0', 'general');
				};

				// Scope functions

				scope.$watch('snData | json', (newValue, oldValue) => {
					if (newValue != oldValue && !!checkData) {
						checkData();

						$timeout(() => {
							if (scope.snData.chosenContract) {
								scope.isStartContractSigned =
									scope.snData.chosenContract.signed;
								scope.startContractId = scope.snData.chosenContract.id;
							} else {
								scope.isStartContractSigned = false;
								scope.startContractId = -1;
							}
						});
					}
				});

				scope.saveEditedContract = function(e) {
					e.preventDefault();
					$(modalID).modal('hide');
					if (scope.editSelectContract && scope.editSelectContract.name) {
						scope.editSelectContract.name = stringModifierService.cutSelectedText(
							scope.editSelectContract.name
						);
						messageService.showToaster(
							's_2',
							'contractTemplates',
							scope.editSelectContract.name
						);
					}
					scope.snData.updatedContract = scope.editSelectContract;
				};

				scope.chooseContract = function() {
					scope.snData.updatedContract = null;
				};

				scope.openEditSelectContract = function(contract, e) {
					e.preventDefault();

					const isRealContract = contract.id;

					if (isRealContract && !scope.snData.updatedContract) {
						scope.editSelectContract = angular.copy(contract);
					} else if (scope.snData.updatedContract) {
						scope.editSelectContract = angular.copy(
							scope.snData.updatedContract
						);
					} else if (!scope.snData.updatedContract && !isRealContract) {
						templateRequestsService
							.getTemplates('contract_full', contract.templateId)
							.subscribe(
								data => editContractTemplateCallback(data),
								error => showErrorMessage()
							);
					} else {
						scope.editSelectContract = angular.copy(scope.editEmptyContractObj);
					}
					$(modalID).modal('show');
				};

				// Helpers functions

				function editContractTemplateCallback(contract) {
					if (contract.id && contract.templateId) delete contract.id;
					if (contract) {
						scope.editSelectContract = angular.copy(contract);
					} else {
						console.error('failed getting contract text');
					}
				}

				function checkData() {
					initSection();
					checkData = undefined;
				}

				function updateChosenContract(newValue, oldValue) {
					if (newValue !== oldValue && !checkData) {
						scope.snData.chosenContract = angular.copy(scope.chosenContract);
					}
				}

				function updateChosenQuestionnaire(newValue, oldValue) {
					if (newValue !== oldValue && !checkData) {
						scope.snData.chosenQuestionnaire = angular.copy(
							scope.chosenQuestionnaire
						);
					}
				}

				scope.$watch('chosenContract | json', updateChosenContract);
				scope.$watch('chosenQuestionnaire | json', updateChosenQuestionnaire);

				function initSection() {
					if (scope.snData.contracts) {
						scope.contracts = scope.snData.contracts;
					}
					if (scope.snData.contract) {
						const contract = angular.copy(scope.snData.contract);
						if (contract.name) {
							contract.name = stringModifierService.addSelectedText(
								contract.name
							);
						}
						scope.contracts.push(contract);
						scope.chosenContract = contract;
						scope.snData.updatedContract = angular.copy(contract);
					}

					if (scope.snData.questionnaires) {
						scope.questionnaires = scope.snData.questionnaires;
					}
					if (scope.snData.questionnaire) {
						const questionnaire = angular.copy(scope.snData.questionnaire);
						if (questionnaire.name) {
							questionnaire.name = stringModifierService.addSelectedText(
								questionnaire.name
							);
						}
						scope.questionnaires.push(questionnaire);
						scope.chosenQuestionnaire = questionnaire;
					}
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/pageInvoiceAndQuote/sectionContractAndQuestion.js